import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from 'components/SearchInput/SearchInput';

export type Props = {
  filter?: string;
  onFilterChange: (filter: string) => void;
};

export const Search: FC<Props> = ({ filter = '', onFilterChange }) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-3">
      <SearchInput
        filter={filter}
        onFilterChange={onFilterChange}
        placeholder={t('common:dataTable.search.placeholder')}
      />
    </div>
  );
};
